import { Component, Input } from '@angular/core';
import { DateTime } from 'luxon';
import { AppComponent } from 'src/app/app.component';
import { GooglePrivacyAgreementComponent } from '../../../shared/components/google-privacy-agreement/google-privacy-agreement.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: 
  [
    GooglePrivacyAgreementComponent
  ]
})
export class FooterComponent {

  @Input() applyLineBreaks: boolean = false;

  year: number = DateTime.now().year;
  
  constructor(public app: AppComponent) {
  }
}
